import { Environments } from "@paddle/paddle-js";

export type ServiceTier = "basic" | "premium" | "enterprise" | "single";

export type PriceIdDictionary = Record<ServiceTier, string>;

export const devPriceIdDictionary: PriceIdDictionary = {
    "basic": "pri_01k0bbhz31dqw15d7jfa9qstpa",
    "premium": "pri_01jzwzyr98gjgzsfd2812ap74q",
    "enterprise": "pri_01jzwzwt4k4173tzxd5gks2emx",
    "single": "pri_01jzwzttag4z6tbxsze0pfv2z9"
};

export const prodPriceIdDictionary: PriceIdDictionary = {
    "basic": "pri_01k0d02v0pydt47qhe638ra4dz",
    "premium": "pri_01jzprnv4p00vp3v55er9y67gr",
    "enterprise": "pri_01jzprf91xx2mn8hsnh0cv20e4",
    "single": "pri_01jzpre1raarc47qcerw0982ts"
};

export const usePaddlePriceId = (): PriceIdDictionary =>
{
    if (window.location.host === "www.ianusguard.com")
    {
        return prodPriceIdDictionary;
    }
    else
    {
        return devPriceIdDictionary;
    }
};

export const usePaddleEnv = (): Environments =>
{
    if (window.location.host === "www.ianusguard.com")
    {
        return "production";
    }
    else
    {
        return "sandbox";
    }
};

export const usePaddleClientSideToken = (): string =>
{
    if (window.location.host === "www.ianusguard.com")
    {
        return "live_039e9d05e0455fd465db09b5a0e";
    }
    else
    {
        return "test_e0474e086f2a212713dcb7f44e9";
    }
};